import React, { useState } from 'react';

import { LoaderModal } from '../../../../components/UI/NewLoader/LoaderModal/LoaderModal';

interface IFrameProps {
    iframeSrc: string;
    decodeURL: string;
}

export const Frame = ({ iframeSrc, decodeURL }: IFrameProps) => {
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    return (
        <>
            {loading && <LoaderModal />}
            <iframe
                title={`${iframeSrc}${decodeURL}`}
                src={`${iframeSrc}${decodeURL}`}
                width="720"
                height={window.innerHeight - 132}
                style={{ border: 'none' }}
                onLoad={handleLoad}
                onError={() => console.log('error')}
            />
        </>
    );
};
